export default "__VITE_ASSET__1$DKmq8g__"